import { useTheme } from '@mui/material';

import { ATSConnectHiringRequestCreateFeedbackTestIds } from 'data-testids/ATS';
import { CTAButtonsContainer, Right } from '../../../../styles/scorecardStyles';
import { CTAButtonsProps, ScorecardToSubmit } from '../../../../types/scorecardTypes';
import { GreySecondaryButton } from 'sharedComponents/Buttons/GreySecondaryButton';
import { PrimaryButton } from 'sharedComponents/Buttons';
import {
  primaryButtonOverrideSx,
  secondaryButtonOverrideSx,
} from 'sharedComponents/Buttons/styles';
import { useFormContext } from 'react-hook-form';
import { CandidateFeedbackListModalPane } from 'features/Connect/features/ConnectATSIntegration/enums';

export const CTAButtons: React.FC<CTAButtonsProps> = ({
  hasSelectedScorecard,
  isLoading,
  onCancel,
  onSaveAsDraft,
  onSaveAsCompleted,
}) => {
  const {
    handleSubmit,
    formState: { errors, isValid },
    setValue,
  } = useFormContext<ScorecardToSubmit>();

  const theme = useTheme();
  const submitShouldBeDisabled =
    !hasSelectedScorecard || Object.keys(errors).length > 0 || isLoading || !isValid;

  const handleFinalSubmission = async () => {
    setValue('scorecard_complete', true);
    await handleSubmit(onSaveAsCompleted)();
  };

  return (
    <CTAButtonsContainer>
      <GreySecondaryButton
        dataTestId={ATSConnectHiringRequestCreateFeedbackTestIds.CANCEL_BUTTON}
        onClick={() => onCancel(CandidateFeedbackListModalPane.SCORECARD_LIST)}
        sx={{
          width: !hasSelectedScorecard ? '50%' : '25%',
          marginRight: !hasSelectedScorecard ? theme.spacing(1) : 'inherit',
        }}
      >
        Cancel
      </GreySecondaryButton>
      <Right>
        {hasSelectedScorecard && (
          <GreySecondaryButton
            dataTestId={ATSConnectHiringRequestCreateFeedbackTestIds.SAVE_AS_DRAFT_BUTTON}
            onClick={async () => {
              setValue('scorecard_complete', false);
              await handleSubmit(onSaveAsDraft)();
            }}
            sx={{
              ...secondaryButtonOverrideSx(theme),
              marginRight: theme.spacing(1),
              width: '50%',
            }}
          >
            Save as draft
          </GreySecondaryButton>
        )}
        <PrimaryButton
          dataTestId={ATSConnectHiringRequestCreateFeedbackTestIds.SUBMIT_BUTTON}
          sx={{
            ...primaryButtonOverrideSx(theme),
            width: !hasSelectedScorecard ? '100%' : '50%',
          }}
          type="submit"
          disabled={submitShouldBeDisabled}
          onClick={handleFinalSubmission}
        >
          Submit
        </PrimaryButton>
      </Right>
    </CTAButtonsContainer>
  );
};
